import { MarkersVisualArgs } from "@progress/kendo-react-charts";

export const defaultAxisFormatter = (e: number) => {
  return formatNumber(e);
};

function formatNumber(value: number) {
  return value.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
}

export function defaultMarkerRenderer(e: MarkersVisualArgs) {
  return e.createVisual();
}
